import axios from 'axios';

export const GET_MENU_ITEMS = 'GET_MENU_ITEMS';

// Main menu items.
export const getMenuItems = () => {
  return function(dispatch) {
    return axios.get('https://private-f5bbc-rafaelnogueira.apiary-mock.com/api/menu')
      .then(response => {
        dispatch({ type: GET_MENU_ITEMS, menuItemsPayload: response.data });
      })
      .catch(error => {
        console.log(error);
      });
  };
};
